import { useMediaQuery } from '@mui/material';

/** The design's desktop layouts appear at 960px; below that every surface is the compact mobile one. */
export const DFC_VILLAGE_DESKTOP_MIN_WIDTH = 960;

export const DFC_VILLAGE_DESKTOP_MEDIA = `@media (min-width: ${DFC_VILLAGE_DESKTOP_MIN_WIDTH}px)`;

/** True from 960px up. One hook so every village component switches at the same width. */
const useDfcVillageDesktop = (): boolean =>
  useMediaQuery(`(min-width:${DFC_VILLAGE_DESKTOP_MIN_WIDTH}px)`);

export default useDfcVillageDesktop;
